var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.isSaving
    }
  }, [_vm.action === 'create-shipped-with-issues' ? _c('p', [_vm._v(" Geef per product het aantal op waar de klacht over gaat."), _c('br'), _vm._v(" Er wordt automatisch een crediteringsvoorstel aangemaakt. ")]) : _vm.action === 'add-extra-order-lines' ? _c('p', [_vm._v(" Geef per product het aantal op om na te leveren."), _c('br'), _vm._v(" Elk nageleverd product wordt vastgelegd met een prijs van " + _vm._s(_vm._f("price")(0)) + ". ")]) : _vm.action === 'add-extra-order-lines-and-refund-remaining' ? _c('p', [_vm._v(" Geef per product het aantal op om na te leveren."), _c('br'), _vm._v(" Elk nageleverd product wordt vastgelegd met een prijs van " + _vm._s(_vm._f("price")(0)) + "."), _c('br'), _c('strong', [_vm._v("Voor de rest van de producten wordt een creditering aangemaakt!")])]) : _vm._e(), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('b-table-simple', {
    attrs: {
      "borderless": "",
      "small": ""
    }
  }, [_c('b-thead', [_c('tr', [_c('b-th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v("Aantal")]), _c('b-th', {
    staticStyle: {
      "width": "80px"
    }
  }, [_vm._v("Totaal")]), _c('b-th', {
    staticStyle: {
      "width": "105px"
    }
  }, [_vm._v("Artikel nr")]), _c('b-th', [_vm._v("Naam")]), _vm.showStockInfo ? _c('b-th', [_vm._v(" Voorraad ")]) : _vm._e(), _c('b-th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm.action === 'create-shipped-with-issues' ? _c('span', [_vm._v("Totaalprijs")]) : _vm._e(), _vm.action === 'add-extra-order-lines' ? _c('span', [_vm._v("Oorspronkelijke prijs")]) : _vm._e()])], 1)]), _c('b-tbody', _vm._l(_vm.applicableDispatchRequestsLines, function (dispatchRequestLine) {
    var _dispatchRequestLine$, _vm$getSalesOrderLine;
    return _c('b-tr', {
      key: dispatchRequestLine.id
    }, [_c('b-td', [_c('b-input', {
      staticClass: "d-inline-block",
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "max": dispatchRequestLine.quantity,
        "size": "sm"
      },
      model: {
        value: _vm.selectedProductsPerLine[dispatchRequestLine.id],
        callback: function ($$v) {
          _vm.$set(_vm.selectedProductsPerLine, dispatchRequestLine.id, _vm._n($$v));
        },
        expression: "selectedProductsPerLine[dispatchRequestLine.id]"
      }
    }), _c('b-button', {
      staticClass: "shadow-none",
      attrs: {
        "size": "sm",
        "variant": "link"
      },
      on: {
        "click": function ($event) {
          _vm.selectedProductsPerLine[dispatchRequestLine.id.toString()] = dispatchRequestLine.quantity;
        }
      }
    }, [_vm._v("alles")])], 1), _c('b-td', [_vm._v(_vm._s(dispatchRequestLine.quantity))]), _c('b-td', [_vm._v(_vm._s(dispatchRequestLine.product_identifier))]), _c('b-td', [_vm._v(_vm._s((_dispatchRequestLine$ = dispatchRequestLine.product_name) !== null && _dispatchRequestLine$ !== void 0 ? _dispatchRequestLine$ : (_vm$getSalesOrderLine = _vm.getSalesOrderLine(dispatchRequestLine.sales_order_line_id)) === null || _vm$getSalesOrderLine === void 0 ? void 0 : _vm$getSalesOrderLine.product_name))]), _vm.showStockInfo ? _c('b-td', [_c('product-stock-status', {
      attrs: {
        "product-identifier": dispatchRequestLine.product_identifier,
        "quantity": dispatchRequestLine.quantity,
        "auto-check": ""
      }
    })], 1) : _vm._e(), _c('b-td', [_vm._v(" " + _vm._s(_vm._f("price")(dispatchRequestLine.total_refundable_amount)) + " ")])], 1);
  }), 1)], 1), _c('b-row', [_vm.action === 'add-extra-order-lines' || _vm.action === 'add-extra-order-lines-and-refund-remaining' ? _c('b-col', {
    staticClass: "pb-1"
  }, [_vm._v(" Beloofde leverdatum: "), _c('b-input', {
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "date",
      "min": _vm.tomorrow,
      "size": "sm"
    },
    model: {
      value: _vm.promisedDeliveryDate,
      callback: function ($$v) {
        _vm.promisedDeliveryDate = $$v;
      },
      expression: "promisedDeliveryDate"
    }
  })], 1) : _vm._e(), _c('b-col', {
    staticClass: "text-right mr-1 pb-1"
  }, [_vm.isModal ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.close')) + " ")]) : _vm._e(), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isSubmitDisabled
    }
  }, [_vm.action === 'create-shipped-with-issues' ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.create-shipped-with-issues')) + " ")]) : _vm.action === 'add-extra-order-lines' ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.add-extra-order-lines')) + " ")]) : _vm.action === 'add-extra-order-lines-and-refund-remaining' ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.add-extra-order-lines-and-refund-remaining', {
    totalSelectedCount: this.totalSelectedCount,
    totalUnselectedCount: this.totalUnselectedCount
  })) + " ")]) : _vm.action === 'cancel-multiple-lines' ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.cancel-multiple-lines')) + " ")]) : _vm.action === 'unable-to-ship-final' ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.dispatch-requests.final-action-titles.unable-to-ship-final')) + " ")]) : _vm._e()])], 1)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }